import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

import { TAssignmentForm } from '@containers/Forms/Assignment/schema'
import { TTaskForm } from '@containers/Forms/Task/schema'

interface IAssignmentForm extends TAssignmentForm {
  dummyAssignmentId: string
}

interface IAddTaskContextData {
  assignmentsData: IAssignmentForm[] | []
  setAssignmentsData: React.Dispatch<React.SetStateAction<IAssignmentForm[]>>
  taskFormData: Partial<TTaskForm> | undefined
  setTaskFormData: React.Dispatch<
    React.SetStateAction<Partial<TTaskForm> | undefined>
  >
}

interface IProps {
  children: ReactNode
}

const AddTaskContext = createContext<IAddTaskContextData>(
  {} as IAddTaskContextData,
)

const AddTaskProvider = ({ children }: IProps) => {
  const [assignmentsData, setAssignmentsData] = useState<IAssignmentForm[]>([])
  const [taskFormData, setTaskFormData] = useState<
    Partial<TTaskForm> | undefined
  >(undefined)

  const value = useMemo(
    () => ({
      assignmentsData,
      setAssignmentsData,
      taskFormData,
      setTaskFormData,
    }),
    [assignmentsData, taskFormData],
  )

  return (
    <AddTaskContext.Provider value={value}>{children}</AddTaskContext.Provider>
  )
}

const useAddTaskContext = () => {
  const context = useContext(AddTaskContext)

  if (!context) {
    throw new Error('useAddTaskContext must be used within a AddTaskProvider')
  }

  return context
}

export { AddTaskProvider, useAddTaskContext }
